import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { Field } from "../../../../../../../../../components/shared/Form";
import CustomTimeInput from "../../../../../../../../../components/shared/inputs/CustomTimeInput";
import PayCodeSelect from "../../../../../PayCodeSelect";

type BreakProps = {
    name: string;
    index: number;
    remove: () => void;
};

function Break({ name, index, remove }: BreakProps) {
    const { t } = useTranslation();

    return (
        <div key={index} className="tw-flex tw-flex-col">
            <div className="tw-flex tw-items-start tw-gap-2 tw-py-2">
                <span className="tw-flex tw-h-9 tw-items-center tw-text-xs tw-text-neutral-400 tw-w-5 tw-text-right tw-shrink-0">{index + 1}.</span>
                <Field name={`${name}.start`} deps={[`${name}.end`, "startDate", "endDate"]} className="tw-mb-0 tw-flex-1 tw-min-w-28" shouldUnregister={false}>
                    <CustomTimeInput placeholder={t("start")} />
                </Field>
                <span className="tw-flex tw-h-9 tw-items-center tw-text-neutral-300 tw-text-sm tw-shrink-0">→</span>
                <Field name={`${name}.end`} deps={[`${name}.start`, "startDate", "endDate"]} className="tw-mb-0 tw-flex-1 tw-min-w-28" shouldUnregister={false}>
                    <CustomTimeInput placeholder={t("end")} />
                </Field>
                <Field name={`${name}.payCode`} className="tw-mb-0 tw-flex-1 tw-min-w-28" shouldUnregister={false}>
                    <PayCodeSelect
                        params={{ forBreak: true }}
                        className="tw-w-full"
                    />
                </Field>
                <button
                    type="button"
                    onClick={() => remove()}
                    className="tw-shrink-0 tw-ml-auto tw-flex tw-h-7 tw-w-7 tw-mt-1 tw-items-center tw-justify-center tw-rounded-full tw-text-neutral-300 hover:tw-bg-rose-50 hover:tw-text-rose-400 tw-transition-colors"
                >
                    <X size={14} />
                </button>
            </div>
        </div>
    );
}

export default Break;
